import { StandardSvgProps } from "src/components/svg/StandardSvgProps";
import { SDefaultSvg } from 'src/components/svg/SvgStyles';
import styled from "src/lib/styles/css";
//#region [Props]
type FilmQuizHeartSvgProps = {
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function FilmQuizHeartSvg({ className }: FilmQuizHeartSvgProps) {
	return (
		<SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" width="33.961" height="27.921" viewBox="0 0 33.961 27.921">
			<defs>
				<linearGradient id="a" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
					<stop offset="0" stopColor="#9177ff" />
					<stop offset="1" stopColor="#812de2" />
				</linearGradient>
			</defs>
			<HeartPath d="M773.315,318.407a5.211,5.211,0,0,0,7.205,0l10.695-10.56a9.275,9.275,0,0,0,0-13.186,9.445,9.445,0,0,0-13.283,0l-.951.93-.941-.93a9.445,9.445,0,0,0-13.283,0,9.272,9.272,0,0,0,0,13.184Z" transform="translate(-760.005 -291.932)" />
		</SDefaultSvg>
	);
}
//#endregion

//#region [Styles]
const HeartPath = styled.path`
	fill-rule: evenodd;
	fill:url(#a) !important;
`
//#endregion